import { Anchor, Box, Empty, Flex, IconFont, Toast } from '@byecode/ui'
import { APPLICATION_VERSION_STATUS } from '@lighthouse/core'
import { t } from 'i18next'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { openPublishedPanel } from '@/containers/Application/ApplicationHeader/PublishedContent'
import { useApplication } from '@/hooks/useApplication'
import { WxProgramsAuthorizationStatus } from '@/services/types'
import { useWxMiniProgramsAuthorizationResult } from '@/shared/reusable'

const SCxDescription: typeof Box = styled(Box)`
    color: var(--color-gray-400);
    font-size: var(--font-size-sm);
    font-weight: 400;
    line-height: 18px;
`

export const EmptyMiniProgramTemplate: React.FC = () => {
    const app = useApplication()
    const { data: wxMiniProgramsAuthorization } = useWxMiniProgramsAuthorizationResult()
    const { authorizationStatus } = wxMiniProgramsAuthorization || {}
    const isAuthorization = authorizationStatus === WxProgramsAuthorizationStatus.AUTH_SUCCESS

    const handleAuthorization = useCallback(() => {
        if (!app.version.status || app.version.status === APPLICATION_VERSION_STATUS.OFFLINE) {
            Toast.error(t('needPublish'))
            return
        }
        openPublishedPanel('WX_PROGRAMS')
    }, [app.version.status])

    if (isAuthorization) {
        return <Empty py={26} icon={<IconFont type="MiniProgram" color="var(--color-gray-400)" />} description="没有消息模板" />
    }

    return (
        <Flex direction="column" gap={8} px={32} py={14}>
            <IconFont type="MiniProgram" size={20} color="var(--color-gray-400)" />
            <SCxDescription component="p">
                请先将应用发布，并在“分享{'>'}发布为小程序”授权企业认证的小程序，
                {}
                <Anchor to="javascript:void(0)" onClick={handleAuthorization}>
                    前去授权{'>'}
                </Anchor>
            </SCxDescription>
        </Flex>
    )
}
